import { render, staticRenderFns } from "./FirebaseProjectTable.vue?vue&type=template&id=9a732f08&"
import script from "./FirebaseProjectTable.vue?vue&type=script&lang=js&"
export * from "./FirebaseProjectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports